import Accounting from './Accounting.vue'
import MenuItem from "./../../../core/components/menu/MenuItem";
import i18n from '../../../shared/i18n'

let routes = [{
  path: 'accounting',
  name: 'accounting',
  component: Accounting,
  meta: {
    requiresAuth: true
  }
}];

export default {
  menuItem: new MenuItem('/accounting', i18n.t('Accounting'), 39, 'calculator'),
  routes: routes
}
